/**
 * AI 智能分类 · 聚合导出
 *
 * 组件 / 外层 store 只从这里引，不要直达具体 slice 文件。
 * 集中入口方便未来拆分（如把部分子切片外置）或加 thunk middleware。
 */

import { combineReducers } from 'redux'
import session from './sessionSlice'
import messages from './messagesSlice'
import ui from './uiSlice'
import folderSync from './folderSyncSlice'
import folderApi from './folderApiSlice'
import folderList from './folderListSlice'
import task from './taskSlice'
import selection from './selectionSlice'

/** 聚合后的 aiClassify 子树 reducer · 挂到根 store 的 `aiClassify` 键下
 *  注：文件夹配额已升格为顶层 folderQuotaSlice（普通 + AI 文件夹共用），不在本子树 */
export const aiClassifyReducer = combineReducers({
  session,
  messages,
  ui,
  folderSync,
  folderApi,
  folderList,
  task,
  selection
})

/** aiClassify 子树 state 形状 · 供 selectors / RootState 推导使用 */
export type AIClassifyState = ReturnType<typeof aiClassifyReducer>

// ============================================================
// 扁平 re-export · 当前无同名冲突（sessionSlice.reset / messagesSlice.clear 不冲突）
// ============================================================

export * from './sessionSlice'
export * from './messagesSlice'
export * from './uiSlice'
export * from './folderSyncSlice'
export * from './folderApiSlice'
export * from './folderListSlice'
export * from './taskSlice'
export * from './selectionSlice'
export * from './selectors'
export { streamMiddleware } from './streamMiddleware'
